module.exports = __webpack_public_path__ + "static/img/image_solutions_precision_05.da6ab31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_precision_05.png
// module id = J3NX
// module chunks = 10